import { createRouter, createWebHistory } from 'vue-router'
import RoonAuth from '@roonlabs/vue-roon-login'

import EditCampaign from '../views/EditCampaign.vue'
import EditComm from '../views/EditComm.vue'
import Home from '../views/Home.vue'
import Campaigns from '../views/Campaigns2.vue'
import Campaign from '../views/Campaign.vue'
import Error from '../views/Error.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '',
                name: 'Campaigns',
                component: Campaigns
            },
            {
                path: '/campaigns/new',
                name: 'NewCampaign',
                component: EditCampaign,
                props: true
            },
            {
                path: '/campaigns/:campaign_id/edit',
                name: 'EditCampaign',
                component: EditCampaign,
                props: true
            },
            {
                path: '/campaigns/:campaign_id',
                name: 'Campaign',
                component: Campaign,
                props: true
            },
            {
                path: '/campaigns/:campaign_id/new',
                name: 'NewComm',
                component: EditComm,
                props: true
            },
            {
                path: '/campaigns/:campaign_id/:comm_id/edit',
                name: 'EditComm',
                component: EditComm,
                props: true
          },
        ]
    },
    {
        path: '/error',
        name: 'Error',
        component: Error,
    },
]

const router = new createRouter({
    history: createWebHistory(),
    routes
})

RoonAuth.install(router);

export default router
